/**
 * External dependencies
 */
import React, { useState } from 'react';
import ReactConfirmAlert, { confirmAlert } from 'react-confirm-alert'; // Import
import { Stack, TowerProvider, Box, Heading } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Preloader from 'components/preloader';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import Modal from 'components/modal';

/**
 * Style dependencies
 */
import './styles.scss';

const ConfirmCancelScheduledChangesDialog = ({ onClose, onSubmit, ...rest }) => {
	const [submitting, setSubmitting] = useState(false);
	return (
		<TowerProvider>
			<Modal className='cancel-universal-importer__dialog' close={!submitting && onClose} isVisible={true} header={false}>
				<Box
					padding='xxlarge'
					style={{ height: '100%' }}
					display='flex'
					flexDirection='column'
					justifyContent='spaceBetween'
				>
					{submitting && <Preloader />}
					<div className='confirm-alert__title'>Cancel Scheduled Changes</div>
					<div>
						<p>
							Your scheduled subscription changes will be cancelled, and your current subscription will
							remain active.
						</p>
					</div>
					<ButtonGroup alignItems='center' justifyContent='center'>
						<Button disabled={submitting} onClick={onClose}>Cancel</Button>
						<Button
							disabled={submitting}
							primary
							onClick={() => {
								setSubmitting(true);
								return onSubmit()
									.then(() => onClose())
									.catch((error) => console.log(error))
									.finally(() => {
										setSubmitting(false);
									});
							}}
						>
							Continue
						</Button>
					</ButtonGroup>
				</Box>
			</Modal>
		</TowerProvider>
	);
};

export default ConfirmCancelScheduledChangesDialog;
